import * as actionTypes from './actionTypes';
// import { MyAnnouncementModel } from '@app/src/views/MyAccount/listAvailable/models/AnnouncementModel';

interface State {
  data: any;
  isFetching: boolean;
  error: boolean;
  dataDelete: any;
  isFetchingDelete: boolean;
  errorDelete: boolean;
  selecteds: any[];
  isFetchingRepublish: boolean;
  errorRepublish: boolean;
  dataRepublish: any;
  currentState: number;
  currentPage: number;
  dataPutInactive: any;
  isFetchingPutInactive: boolean;
  errorPutInactive: boolean;
}

const initialState: State = {
  data: {},
  isFetching: false,
  error: false,
  dataDelete: {},
  isFetchingDelete: false,
  errorDelete: false,
  selecteds: [],
  dataRepublish: {},
  isFetchingRepublish: false,
  errorRepublish: false,
  currentState: 1,
  currentPage: 1,
  dataPutInactive: {},
  isFetchingPutInactive: false,
  errorPutInactive: false
}

export const announcement = (state = initialState, action): State => {
  switch (action.type) {
    case actionTypes.FETCH_ANNOUNCEMENT_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case actionTypes.FETCH_ANNOUNCEMENT_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: true
      }
    case actionTypes.FETCH_ANNOUNCEMENT_SUCCESS:
      const ads = action.data.ads;
      const buildCheckedOption = ads.map(item => ({
        categoryId: item.categoryId,
        uniqueId: item.uniqueId,
        type: item.type,
        adId: item.adId,
        checked: false
      }))
      return {
        ...state,
        isFetching: false,
        error: false,
        data: action.data,
        selecteds: buildCheckedOption
      }
    case actionTypes.DELETE_ANNOUNCEMENT_REQUEST:
      return {
        ...state,
        isFetchingDelete: true
      }
    case actionTypes.DELETE_ANNOUNCEMENT_FAILURE:
      return {
        ...state,
        isFetchingDelete: false,
        errorDelete: true
      }
    case actionTypes.DELETE_ANNOUNCEMENT_SUCCESS:
      return {
        ...state,
        isFetchingDelete: false,
        errorDelete: false,
        dataDelete: action.data
      }
    case actionTypes.SELECT_ANNOUNCEMENT:
      const updated = state.selecteds.map(item => {
        if (item.uniqueId === action.uniqueId) {
          return {
            ...item,
            checked: action.checked
          }
        }
        return {
          ...item
        }
      });
      return {
        ...state,
        selecteds: [...updated]
      }
    case actionTypes.CLEAR_ANNOUNCEMENT_SELECTEDS:
      const cleanData = state.selecteds.map(item => ({
        ...item,
        checked: false
      }));
      return {
        ...state,
        selecteds: cleanData
      }
    case actionTypes.CLEAR_ANNOUNCEMENT_DELETE_DATA:
      return {
        ...state,
        isFetchingDelete: false,
        errorDelete: false,
        dataDelete: {}
      }
    case actionTypes.CLEAR_ANNOUNCEMENT_PUT_INACTIVE_DATA:
      return {
        ...state,
        isFetchingPutInactive: false,
        errorPutInactive: false,
        dataPutInactive: {}
      }
    case actionTypes.REPUBLISH_ANNOUNCEMENT_REQUEST:
      return {
        ...state,
        isFetchingRepublish: true
      }
    case actionTypes.REPUBLISH_ANNOUNCEMENT_FAILURE:
      return {
        ...state,
        isFetchingRepublish: false,
        errorRepublish: true
      }
    case actionTypes.REPUBLISH_ANNOUNCEMENT_SUCCESS:
      return {
        ...state,
        isFetchingRepublish: false,
        errorRepublish: false,
        dataRepublish: action.data
      }
    case actionTypes.CLEAR_ANNOUNCEMENT_REPUBLISH_DATA:
      return {
        ...state,
        isFetchingRepublish: false,
        errorRepublish: false,
        dataRepublish: {}
      }
    case actionTypes.SET_ANNOUNCEMENT_STATE:
      return {
        ...state,
        currentState: action.state
      }
    case actionTypes.SET_ANNOUNCEMENT_PAGE:
      return {
        ...state,
        currentPage: action.page
      }
    case actionTypes.PUT_ANNOUNCEMENT_REQUEST:
      return {
        ...state,
        isFetchingPutInactive: true
      }
    case actionTypes.PUT_ANNOUNCEMENT_FAILURE:
      return {
        ...state,
        isFetchingPutInactive: false,
        errorPutInactive: true
      }
    case actionTypes.PUT_ANNOUNCEMENT_SUCCESS:
      return {
        ...state,
        isFetchingPutInactive: false,
        errorPutInactive: false,
        dataPutInactive: action.data
      }
    default:
      return state;
  }
}
